import { paginate } from '@/utils/function';
import { get as getObjectPath } from 'lodash';

export default {
	computed: {
		resultCounter() {
			const totalCount = getObjectPath(
				this.tableSource,
				'source.totalCount',
				0
			);
			return totalCount;
		},
		hasResults() {
			return this.resultCounter > 0;
		}
	},
	methods: {
		generateSource(page, pageSize) {
			let items = [];
			let search = decodeURIComponent(this.searchReference);
			if (
				this.impactInputFieldsList &&
				this.impactInputFieldsList.length
			) {
				items = [...this.impactInputFieldsList];
			}

			let source = {
				page: page || 1,
				countPerPage: pageSize,
				totalPageCount: 0,
				totalCount: 0,
				pageSize: pageSize,
				items: []
			};
			if (items.length) {
				if (search) {
					search = search.toLowerCase();

					items = items.reduce((fieldsList, obj) => {
						const description =
							obj.description && obj.description.toLowerCase();
						const formsSnippetsId =
							obj.formsSnippetsId &&
							obj.formsSnippetsId.toString();
						if (
							(description && description.includes(search)) ||
							(formsSnippetsId &&
								formsSnippetsId.includes(search))
						)
							fieldsList.push(obj);
						return fieldsList;
					}, []);
				}

				let itemsSorted = this.sortedResponse(
					[...items],
					['row', 'dot', 'col']
				);

				const maxPage = Math.ceil(itemsSorted.length / pageSize);
				let pagination = paginate(
					itemsSorted.length,
					page,
					pageSize,
					maxPage
				);

				Object.assign(source, {
					totalPageCount: pagination.pages.length,
					totalCount: itemsSorted.length,
					pageSize: pageSize,
					items: itemsSorted.slice(
						pagination.startIndex,
						pagination.endIndex + 1
					)
				});
			}

			this.tableSource.source = source;
		},
		updatePagination(obj) {
			if (this.dataPage !== obj.page) {
				this.dataPage = obj.page;
			}
			if (this.pageSize !== obj.countPerPage) {
				this.pageSize = obj.countPerPage;
			}
		},
		sortedResponse(impactInputFields, list) {
			return impactInputFields.sort(function(a, b) {
				for (let prop of list) {
					if (a[prop] < b[prop]) return -1;
					if (a[prop] > b[prop]) return 1;
				}
				return 0;
			});
		},
		formImpactType(value) {
			if (value === 'S') {
				return 'static';
			} else if (value === 'I') {
				return 'client input';
			} else if (value === 'C') {
				return 'code';
			} else {
				return 'not defined';
			}
		},
		formFieldReferences(obj) {
			if (obj.impactType === 'S') {
				return obj.staticValue;
			} else if (obj.impactType === 'I') {
				return obj.keyboardPrompt;
			} else {
				return obj.description;
			}
		},
		hasRowColErrorValue(value) {
			if (Math.sign(value) === -1) {
				return 'negative';
			}
			return '';
		},
		hasDotErrorValue(value) {
			if (Math.sign(value) === -1 || value > 11) {
				return 'negative';
			}
			return '';
		},
		errorRowColMessage(value) {
			if (Math.sign(value) === -1) {
				return 'not allowed';
			}
			return '';
		},
		errorDotMessage(value) {
			if (Math.sign(value) === -1 || value > 11) {
				return 'not allowed';
			}
			return '';
		}
	},
	watch: {
		dataPage: {
			handler(page) {
				this.generateSource(page, this.pageSize);
			}
		},
		pageSize: {
			handler(pageSize) {
				this.generateSource(1, pageSize);
			}
		},
		searchReference: {
			handler() {
				this.generateSource(1, 10);
			}
		}
	}
};
